import { ApplicationStatus } from './application-status';
import { ApplicationStep } from './application-step';

export const getStatusIdForStep = (step: ApplicationStep, statuses: ApplicationStatus[]) =>
  statuses.find((status) => status.step === step)?.id;
